angular.module('surfsightApp.controllers').controller('geofenceDetailsCtrl', [
  '$scope',
  '$mdDialog',
  'dataFromCaller',
  function editEdgeController ($scope, $mdDialog, dataFromCaller) {
    $scope.geofence = dataFromCaller.geofence
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
  }
])
